import { render, staticRenderFns } from "./BannerCustomHeroCreate.vue?vue&type=template&id=9948ebc4&"
import script from "./BannerCustomHeroCreate.vue?vue&type=script&lang=js&"
export * from "./BannerCustomHeroCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports